import { Dispatcher, GetStore } from '../Store';
import { IConfigurationService } from '../../services/index';
import { IApiInformation } from '../../models';
import { API_INFORMATION_LOADED } from './apiInformation.constants';

export interface IApiInformationActionsService {
    getApiInformation(): Dispatcher<IApiInformation>;
}

export class ApiInformationActionsService implements IApiInformationActionsService {
    static serviceId = 'apiInformationActionsService';
    static $inject = ['$q', 'configurationService'];

    constructor(
        private _$q: angular.IQService,
        private _configurationService: IConfigurationService
    ) {
    }

    getApiInformation(): Dispatcher<IApiInformation> {
        return (dispatch: any, getState: GetStore) => {
            const info = getState().apiInformation?.value;
            if (!info || !info.buildDate) {
                return this._configurationService
                    .getApiInformation()
                    .then(info => {
                        dispatch({ type: API_INFORMATION_LOADED, payload: info });
                        return info;
                    });
            }
            else {
                return this._$q.when(info);
            }
        };
    }
}